import { Component, EventEmitter, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalWrapperComponent } from './modal-wrapper/modal-wrapper.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-modal-window',
  templateUrl: './modal-window.component.html',
  styleUrls: ['./modal-window.component.scss']
})
export class ModalWindowComponent implements OnInit, OnDestroy {

  @Input() title: string;
  @Input() fullscreen: boolean = false;
  @Input() hasBackdrop: boolean = true;
  @Input() showModal: EventEmitter<boolean>;

  @ViewChild('modalContent') component: TemplateRef<HTMLElement>;
 
  private dialogRef: MatDialogRef<ModalWrapperComponent>;
  private unsub$: Subject<void> = new Subject();

  constructor(public dialog: MatDialog) {}

  public ngOnInit(): void {
    this.showModal?.pipe(takeUntil(this.unsub$)).subscribe(
      (isShow: boolean) => isShow ? this.openModal() : this.closeModal()
    );
  }

  public ngOnDestroy(): void {
    this.unsub$.next();
    this.unsub$.complete();
  }

  private openModal() {
    // zero delay for correct title update
    setTimeout(() => {
      this.dialogRef = this.dialog.open(ModalWrapperComponent, {
        data: {
          title: this.title,
          component: this.component,
          fullscreen: this.fullscreen,
        },
        width: '480px',
        maxHeight: '90vh',
        hasBackdrop: this.hasBackdrop,
      });
    }, 0)
  }

  private closeModal() {
    this.dialogRef?.close();
  }
}
